(function () {
  function isZeroPrice(text) {
    return /(?:regular price\s*)?(?:USD\s*)?\$?\s*0(?:[.,]00)?(?:\s*USD)?/i.test(text.trim());
  }

  function hideZeroComparePrices(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const compareNodes = scope.querySelectorAll(
      'compare-at-price, .compare-at-price, .price-item--regular, .price__regular'
    );

    compareNodes.forEach((node) => {
      if (isZeroPrice(node.textContent)) {
        node.style.setProperty('display', 'none', 'important');
        node.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function normalizePriceText(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const priceNodes = scope.querySelectorAll(
      'product-price .price, product-price .price-item--sale, product-price .compare-at-price, .sticky-add-to-cart__price .price, [data-testid="sticky-price-display"] .price'
    );

    priceNodes.forEach((node) => {
      const normalized = node.textContent
        .replace(/\$\s+/g, '$')
        .replace(/USD\s*/g, '$')
        .replace(/\s+USD/g, '');

      if (node.textContent !== normalized) {
        node.textContent = normalized;
      }

      node.style.letterSpacing = '0';
      node.style.wordSpacing = '0';
      node.style.whiteSpace = 'nowrap';
    });

    hideZeroComparePrices(scope);
  }

  normalizePriceText(document);

  document.addEventListener('DOMContentLoaded', () => normalizePriceText(document));
  window.addEventListener('load', () => normalizePriceText(document));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') {
        normalizePriceText(mutation.target.parentElement);
        continue;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          normalizePriceText(node);
        }
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
